import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { BACKEND_URL } from "@/lib/api";

const resolveImg = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/files/")) return `${BACKEND_URL}${url}`;
  return url;
};

export default function JournalPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    setPost(null);
    api
      .get(`/journal/${slug}`)
      .then((r) => {
        setPost(r.data);
        document.title = `${r.data.title} — Ram Shack Journal`;
      })
      .catch(() => setPost(false));
  }, [slug]);

  if (post === null) {
    return <div className="px-6 py-32 text-muted-bone text-center">Loading…</div>;
  }
  if (post === false) {
    return (
      <div className="px-6 py-32 text-center">
        <div className="font-serif-display text-3xl text-bone mb-4">This letter was never written.</div>
        <Link to="/journal" className="overline">← Back to the journal</Link>
      </div>
    );
  }

  return (
    <article data-testid="journal-post-page" className="px-6 md:px-12 lg:px-16 py-16 md:py-24">
      {post.json_ld && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(post.json_ld) }}
        />
      )}
      <div className="max-w-3xl mx-auto">
        <Link to="/journal" className="overline mb-8 inline-block" data-testid="journal-back-link">
          ← The Journal
        </Link>
        <div className="overline mb-4">
          {post.published_at?.slice(0, 10)} · {post.author || "The House"} · {post.reading_time} min read
        </div>
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-bone leading-tight mb-10">
          {post.title}
        </h1>
        {post.hero_image && (
          <div className="aspect-[16/9] overflow-hidden mb-12" style={{ background: "var(--rs-surface-2)" }}>
            <img src={resolveImg(post.hero_image)} alt={post.title} className="w-full h-full object-cover" />
          </div>
        )}
        <div
          data-testid="journal-post-content"
          className="journal-content text-muted-bone leading-relaxed space-y-6 text-base"
          dangerouslySetInnerHTML={{ __html: post.content_html }}
        />
        <div className="mt-16 pt-8 border-t flex flex-wrap gap-2" style={{ borderColor: "var(--rs-border)" }}>
          {(post.tags || []).map((t) => (
            <span
              key={t}
              className="text-[10px] uppercase tracking-[0.2em] text-muted-bone border px-2 py-1"
              style={{ borderColor: "var(--rs-border)" }}
            >
              {t}
            </span>
          ))}
        </div>
        <div className="mt-12 text-center">
          <Link
            to="/shop"
            data-testid="journal-shop-cta"
            className="inline-block px-10 py-4 uppercase text-xs tracking-[0.22em] text-bone hover:opacity-90 transition"
            style={{ background: "var(--rs-oxblood)" }}
          >
            Wander the collection
          </Link>
        </div>
      </div>
    </article>
  );
}
